// extracted by mini-css-extract-plugin
module.exports = {"Modal":"Modal_Modal__2x8O8","Open":"Modal_Open__3dIo-","Overlay":"Modal_Overlay__uy01g"};